/* eslint-disable react/prop-types */
import { Spinner } from 'react-bootstrap';

const Loader = ({ height = 'h-100vh' }) => (
  <div className={`d-flex ${height} justify-content-center align-items-center`}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

export default Loader;
